<template>
  <div id="app">
    <Navbar :mme="$route.meta.mme ? true : false" v-if="logged && !$route.meta.hideNavbar"></Navbar>
    <Loader></Loader>
    <DeclareBug v-if="declareBugRight"></DeclareBug>
    <div id="app-content" :class="{mme: $route.meta.mme, 'nomargin': $route.meta.appNoMargin}"
         v-if="logged && infoLoaded">
      <router-view/>
    </div>
    <Footer :mme="$route.meta.mme ? true : false" v-if="logged && !$route.meta.hideFooter"></Footer>
  </div>
</template>

<script>
import Vue from "vue";
import jwt_decode from "jwt-decode";
import Loader from "@/components/Loader";
import DeclareBug from "@/components/DeclareBug";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import {verifyModuleRights} from "./utils/module";
import {getCurrentModuleUrl} from "./utils";

export default {
  name: 'App',
  components: {Loader, DeclareBug, Navbar, Footer},
  data() {
    return {
      logged: false,
      reqPending: false,
      infoLoaded: false,
      declareBugRight: false
    }
  },
  methods: {
    auth() {
      // Récupère les paramètre de l'URL
      const login = new URL(window.location.href).searchParams.get("login");
      const email = new URL(window.location.href).searchParams.get("email");
      const autologinHash = new URL(window.location.href).searchParams.get("autologinHash");

      let localToken = window.localStorage.getItem("jwt");
      if (localToken) this.saveTokenData(localToken);

      else {
        // Demande un token au serveur avec les identifiants
        this.reqPending = true;
        this.$store.commit("displayLoader", true);
        Vue.axios.get(`${this.$store.state.rootApi}auth?login=${login}&email=${email}&autologinHash=${autologinHash}`)
          .then((res) => {
            const {data: token} = res;
            this.saveTokenData(token);
          }).catch((err) => {
          if (err.response && err.response.status === 400)
            this.$store.commit("redirectToConnect");
        }).finally(() => {
          this.reqPending = false;
          this.$store.commit("displayLoader", false);
        })
      }

    },
    saveTokenData(token) {
      window.localStorage.setItem("jwt", token);
      let jsonUser = jwt_decode(token);
      jsonUser = jsonUser["http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata"];
      const user = JSON.parse(jsonUser); // Récupère les informations de l'utilisateur via token reçu
      // Vérifie si fournisseur
      const newSelf = {}
      newSelf.id = user.UserId;
      newSelf.userSdcGuid = user.UserSdcGuid;
      newSelf.isSupplier = user.TiersType == "FOU" ? 1 : 0;
      newSelf.isAdmin = (user.IsAdmin && user.TiersType == "CME") ? 1 : 0;
      newSelf.guid = user.TiersSdcGuid;
      newSelf.name = user.UserName;
      newSelf.firstname = user.UserFirstname;
      newSelf.code = user.IdCompta;
      newSelf.nom = user.TiersLibelle;
      newSelf.isLnL = user.IsLnL;
      newSelf.isLS = user.IsLS;
      newSelf.accessOdw = user.AccesOdw3;
      newSelf.accessDor = user.AccesOdw4;
      newSelf.token = token;
      newSelf.family = user.Family;
      newSelf.TOTPVerified = user.TOTPVerified;
      newSelf.TOTPVerifiedModuleUrl = user.TOTPVerifiedModuleUrl;
      newSelf.AutoLoginCle = user.AutoLoginCle;
      this.$store.commit("updateSelf", newSelf)
      this.logged = true;

      verifyModuleRights("ticket-demande").then(res => {
        if (res) this.declareBugRight = true;
      })
    },
    verifyAndRedirect() {
      this.infoLoaded = false;
      const moduleUrl = getCurrentModuleUrl();
      if (this.logged && moduleUrl !== "") {
        verifyModuleRights(moduleUrl).then((res) => {
          if (!res) {
            this.$router.replace("/");
          } else {
            this.loadInfos();
          }
        })
      }
      if (moduleUrl == "") {
        this.infoLoaded = true;
      }
    },
    loadInfos() {
      const moduleUrl = getCurrentModuleUrl();
      if (moduleUrl == "tickets" || moduleUrl == "ticket-demande" || moduleUrl == "fiche-livraison") {
        if (this.$store.state.trelloConfig.loaded) {
          this.infoLoaded = true;
        } else {
          this.$store.dispatch("loadTrelloConfig").then(() => {
            this.infoLoaded = true;
          });
        }
      } else {
        this.infoLoaded = true;
      }
    },
  },
  watch: {
    logged() {
      this.verifyAndRedirect();
    },
    $route() {
      this.verifyAndRedirect();
    }
  },
  mounted() {
    this.auth();
  },
}
</script>

<style>

@font-face {
  font-family: "DIN Pro";
  src: local("DIN Pro"), url("./assets/font/din-regular-webfont.ttf") format('truetype');
}

@font-face {
  font-family: "DIN Bold";
  src: local("DIN Bold"), url("./assets/font/din-bold-webfont.ttf") format('truetype');
}

@font-face {
  font-family: "DIN Light";
  src: local("DIN Light"), url("./assets/font/din-light-webfont.ttf") format('truetype');
}

:root {
  --primary: #63CEB6;
  --secondary: #50E3C2;
}


html, body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  padding: 0;
  margin: 0;
  background: #F1F1F1 !important;
  font-family: "DIN Pro";
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  /*    margin-top: 195px;*/
}

#app-content {
  margin: 0 2%;
  box-sizing: border-box;
  min-height: calc(100vh - 53px - 16px - 175px - 160px - 60px);

}

#app-content h1 {
  text-transform: uppercase;
  font-size: 1.5em;
  padding-left: 7px;
  border-left: 5px solid #80a70e;
  margin-bottom: 1.5em;
}

#app-content.nomargin {
  margin: 0;
}

#app-content.mme h1 {
  border-left-color: black;
}

button {
  background-color: #FFFFFF;
  border: 1px solid #ced4da;
  padding: 10px;
  border-radius: 6px;
}

.button-primary {
  background: #A7C13C;
  color: #FFFFFF;
}

button:hover {
  cursor: pointer;
}

table {
  background: #FFFFFF;
}

option {
  font-family: "Calibri";
}

.label {
  padding: .2em .6em .3em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: .25em;
  margin-right: 1px;
}

.label-green {
  background: rgb(97, 189, 79);
}

.label-purple {
  background: rgb(195, 119, 224);
}

.label-sky {
  background: rgb(0, 194, 224);
}

.label-black {
  background: rgb(52, 69, 99);
}

.label-generique {
  background: #BDBDBD;
}

.label-red {
  background: rgb(235, 90, 70);
}

.label-orange {
  background: rgb(255, 159, 26);
}

.label-yellow {
  background: rgb(242, 214, 0);
}

.white-box {
  padding: 4px;
  border-radius: 6px;
  background-color: white;
  box-shadow: 1px 1px 10px 0 rgba(0, 0, 0, 0.2);
}

</style>



// WEBPACK FOOTER //
// src/App.vue